/**
 * @description 即时评价组件配置
 */

export const evaluateConfig = {
    env: 'prod', // 所在的当前环境：sit、uat、ver、prod，
    userInfo: {
        user_name: '', // mip账号（姓名）
        user_id: '' // mip账号
    },
    templeteInfo: {
        closeCountdown: false, // 关闭倒计时功能
        clickOpenModal: false,
        appType: 'pc', // 终端类型 pc、app
        modeType: '', // 弹框挂件展示类型 hover: 挂件式(悬浮右下角) inner:嵌入  默认:''不展示任何挂件
        business: '物流领域', // 领域 eg: 内销领域
        system: 'C-SNP', // 系统 eg: 美云销
        product: 'GWMS仓储服务产品', // 产品 eg: TPC交易与履约中心
        scene: 'C-SNP页面右侧', // 投放位置, 挂件式一般放页面右下角，eg: 人才搜索右侧
        primaryColor: '', // 提交按钮的主色调,默认：#0888ff
        hoverBtnColor: '', // 提交按钮在hover时候的颜色， 默认：#39a0ff
        hoverTagColor: '' // tag标签在hover时候的颜色 默认：#ebf5ff
        // pendantBottom: '10'
    }
};
